import dayjs from "dayjs";

export function describeMonthlyRecurrence(n: number) {
  if (n === 1) return "each month";
  return `every ${n} months`;
}

export function formatDateTime(date: Date | string | undefined): string {
  if (!date) return "";
  if (typeof date === "string") date = new Date(date);
  const datePart = date.toLocaleDateString();
  const timePart = timeFormat12Hour(date);
  return `${datePart} ${timePart}`;
}

function timeFormat12Hour(date: Date) {
  let h = date.getHours();
  const m = date.getMinutes();
  const ampm = h >= 12 ? "pm" : "am";

  h = h % 12;
  h = h === 0 ? 12 : h;

  const formatedTimeString = `${h}:${m.toString().padStart(2, "0")} ${ampm}`;
  return formatedTimeString;
}

export function formatDate(date: Date | string | undefined, includeYear: boolean = false): string {
  if (!date) return "";
  if (typeof date === "string") date = new Date(date);

  return includeYear ? dayjs(date).format("ddd D MMMM YYYY") : dayjs(date).format("ddd D MMMM");
}

const LONG_MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const SHORT_MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function getMonthName(month: number, options?: { short: boolean }) {
  return options?.short ? SHORT_MONTHS[month] : LONG_MONTHS[month];
}

export function formatShortDate(date: Date | string | undefined): string {
  if (!date) return "";
  if (typeof date === "string") date = new Date(date);
  const day = date.getDate().toString().padStart(2, "0");
  const month = SHORT_MONTHS[date.getMonth()];
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}

export function getIndexOfMonthStartingWith(monthPrefix: string) {
  const prefix = monthPrefix.toLowerCase();
  return LONG_MONTHS.findIndex(m => m.toLowerCase().startsWith(prefix));
}

/**
 * The built in toISOString always gives it in UTC time
 */
export function toLocalISOString(date: Date): string {
  return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date
    .getDate()
    .toString()
    .padStart(2, "0")}`;
}

export function toDateOnly(date: Date): string {
  return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date
    .getDate()
    .toString()
    .padStart(2, "0")}`;
}

export function toMonthOnly(date: Date): string {
  return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}`;
}
